// import config from '@/config'
// import lib from '@/library'

// var sizeTemplate = lib.cdu.urlParameters.getTemplate
// var maxNumOfSelectionsPerCol = appConfig.maxNumOfSelectionsPerColSingleEvent
// var marketHeaderHeightComparedToSelection = 0.829
// var big3MarketHeightComparedToSelection = 2.52
// var gapBetweenSelectionsComparedToSelection = 0.055

// function calculateHeightComparedToSelection () {
//   return urlParameters.getBrand() === config.app.brands.default
// }

function isAnotherEvent (oldEvent, newEvent) {
  var result = true

  if (oldEvent && newEvent && oldEvent.idfoevent && newEvent.idfoevent && oldEvent.idfoevent === newEvent.idfoevent) {
    result = false
  }

  return result
}

function indexesOfSameEvent (oldEvents, newEvents) {
  var result = []

  if (oldEvents && newEvents && Array.isArray(oldEvents) && Array.isArray(newEvents)) {
    oldEvents.forEach((eventOld, indexOld) => {
      if (newEvents[indexOld] && eventOld.idfoevent && newEvents[indexOld].idfoevent && newEvents[indexOld].idfoevent === eventOld.idfoevent) {
        result.push(indexOld)
      }
    })
  }

  return result
}

export default {
  isAnotherEvent,
  indexesOfSameEvent
}



// WEBPACK FOOTER //
// ./src/library/cdu/templates/singleEvent.js